"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentItems = getContentItems;
function getContentItems(response) {
    var _a;
    return Array.isArray((_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.items) ? response.content.items : [];
}
